<template>
  <div>
    <v-btn id="students-clear-filters" flat small
           v-if="fromStudents && flagDisplaySaveFilter" @click="showModal"
           class="caption float-right filter-actions-icon ma-0 mt-2"
           :title="$t('filters.save_filter')" :aria-label="$t('filters.save_filter')"
           :disabled="!filtersApplied">
      <v-icon small class="mr-1 hidden-lg-and-down">save</v-icon>
      <v-tooltip bottom>
        <v-icon medium slot="activator" class="mr-1 hidden-xl-only">save</v-icon>
        <span v-html="$t('filters.save_filter')"></span>
      </v-tooltip>
      <h4 class="filter-actions-text">{{ $t('filters.save_filter') }}</h4>
    </v-btn>
    <v-dialog v-model="modal" v-if="modal" max-width="300" persistent>
      <v-form id="filter-save-form" v-model="valid" ref="form" lazy-validation>
        <v-card>
          <v-card-title class="justify-center">
            <v-btn icon class="close" @click="closeModal">
              <v-icon>close</v-icon>
            </v-btn>
            <h2 class="text-xs-center">{{$t('student.filters.save_filter')}}</h2>
          </v-card-title>
          <v-card-text>
            <v-layout row justify-start>
              <v-text-field
                id="students-filter-title-field"
                v-model="studentsFilterTitle"
                class="pt-1"
                clearable
                required
                :rules="requiredRule"
                :placeholder="$t('student.filters.filter_title')">
              </v-text-field>
            </v-layout>
            <v-layout row justify-start>
              <v-flex>
                <v-checkbox id="students-filter-default-cbox"
                            hide-details
                            v-model="defaultSearch"
                            :label="$t('my_filter_save_default')"/>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout row justify-center class="mb-3">
              <v-btn id="students-filter-cancel-btn" @click="closeModal">{{$t('student.filters.cancel')}}</v-btn>
              <v-btn id="students-filter-submit-btn" @click="saveModal" color="primary">{{$t('student.filters.save')}}</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
  import Helpers from '../../mixins/Helpers'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { SET_UNDO_TYPE, SET_INFORMATION_SNACKBAR_STATE, SET_INFORMATION_SNACKBAR_TEXT } from '../../store/mutation-types'
  import { SET_UNDO_STATE_ASYNC, SAVE_UPDATE_MY_FILTER } from '../../store/action-types'
  import { informationTexts } from '../../store/modules/information'

  export default {
    name: 'save-my-filter',
    mixins: [Helpers],
    data () {
      return {
        modal: false,
        valid: false,
        filterTitle: '',
        defaultSearch: false,
        requiredRule: [
          v => (v ? !!v.trim() : !!v) || this.$t('field_required'),
          v => (v && !this.nameExists(v)) || this.$t('filters.must_be_unique')
        ]
      }
    },
    methods: {
      showModal () {
        this.modal = true
      },
      resetForm () {
        this.modal = false
        this.filterTitle = ''
      },
      closeModal () {
        this.resetForm()
        this.setSnackBarText(informationTexts.SAVE_FILTER_CANCEL)
        this.setSnackBar(true)
      },
      saveModal () {
        // only save filter if passed validation
        if (this.$refs.form.validate()) {
          this.savedFilterText(this.title)

          let obj = this.isNew
            ? {description: this.title, defaultSearch: this.defaultSearch}
            : {description: this.title, defaultSearch: this.defaultSearch, id: this.selectedFilterText.id}
          this.saveMyFilter(obj)
          this.resetForm()
        }
      },
      ...mapActions({
        setUndoSnackBar: SET_UNDO_STATE_ASYNC,
        saveMyFilter: SAVE_UPDATE_MY_FILTER
      }),
      ...mapMutations({
        setUndoType: SET_UNDO_TYPE,
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE
      }),
      nameExists (value) {
        return this.filterTypes.myFilterIds.myFilters.filter(el => el.description.toLowerCase() === value.toLowerCase().trim() && !el.isHidden).length > 0 && this.isNew
      }
    },
    computed: {
      title () {
        return this.filterTitle.length > 0 ? this.filterTitle.trim() : this.selectedFilterText.title
      },
      isNew () {
        return this.title !== this.selectedFilterText.title
      },
      ...mapState({
        filterTypes: state => state.students.filterFields
      }),
      studentsFilterTitle: {
        get () {
          this.defaultSearch = this.selectedFilterText.defaultSearch ? this.selectedFilterText.defaultSearch : false
          // return this.selectedFilterText.title
          return this.selectedFilterText.title ? this.selectedFilterText.title : this.filterTitle
        },
        set (value) {
          if ((value) && value.length > 0) {
            this.filterTitle = value
          }
        }
      }
    },
    props: {
      dialog: {
        default: false
      },
      selectedFilterText: {
        type: Object
      },
      savedFilterText: {
        type: Function
      },
      fromStudents: {

      },
      flagDisplaySaveFilter: {

      },
      filtersApplied: {

      }
    }
  }
</script>

<style scoped>
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/SaveMyFilter.vue